import gql from 'graphql-tag';

export const serviceOrderTypeFragment = gql`
  fragment serviceOrderTypeParts on ServiceOrderType {
    code
    label
  }
`;

export const serviceOrderStatusFragment = gql`
  fragment serviceOrderStatusParts on ServiceOrderStatus {
    code
    label
    date
    responsible
  }
`;

export const serviceOrderCurrentStatusFragment = gql`
  fragment serviceOrderCurrentStatusParts on ServiceOrderCurrentStatus {
    code
    label
    date
  }
`;

export const serviceOrderTechnicianFragment = gql`
  fragment serviceOrderTechnicianParts on ServiceOrderTechnician {
    name
    urlPhoto
  }
`;

export const serviceOrderPlaceFragment = gql`
  fragment serviceOrderPlaceParts on ServiceOrderPlace {
    id
    name
  }
`;

export const serviceOrderDefectFragment = gql`
  fragment serviceOrderDefectParts on ServiceOrderDefect {
    id
    description
  }
`;

export const serviceOrderFragment = gql`
  fragment serviceOrderParts on ServiceOrder {
    id
    ticketNumber
    description
    type {
      ...serviceOrderTypeParts
    }
    status {
      ...serviceOrderStatusParts
    }
    currentStatus {
      ...serviceOrderCurrentStatusParts
    }
    startDate
    endDate
    registeredBy
    observationStarted
    observationClosed
    technician {
      ...serviceOrderTechnicianParts
    }
    technicians {
      ...serviceOrderTechnicianParts
    }
    maintenancePlaces {
      ...serviceOrderPlaceParts
    }
    defect {
      ...serviceOrderDefectParts
    }
    places {
      ...serviceOrderPlaceParts
    }
  }
  ${serviceOrderTypeFragment}
  ${serviceOrderStatusFragment}
  ${serviceOrderCurrentStatusFragment}
  ${serviceOrderTechnicianFragment}
  ${serviceOrderPlaceFragment}
  ${serviceOrderDefectFragment}
`;
